import {LanguageProps} from '@nxsys/types/models/Apps';

const languageData: LanguageProps[] = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
  },
  {
    languageId: 'chinese',
    locale: 'zh',
    name: 'Chinese',
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Spanish',
  },
  {
    languageId: 'french',
    locale: 'fr',
    name: 'French',
  },
  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italian',
  },
  {
    languageId: 'saudi-arabia',
    locale: 'ar',
    name: 'Arabic',
  },
];
export default languageData;
